import { LeafMimeNode, MimeNode, MultipartMimeNode } from '../mime-tree/types';

function getHtmlNodeOfMultipartAlternative(node: MimeNode): LeafMimeNode {
	if (node.mimeNodeType !== 'multipart' || node.contentType !== 'multipart/alternative') {
		throw new Error('Expected input to be multipart/alternative');
	}

	const htmlNodes = node.children.filter(childNode => childNode.contentType === 'text/html');
	if (htmlNodes.length >= 1 && htmlNodes[0].mimeNodeType === 'leaf') {
		if (htmlNodes.length > 1) {
			// Try the first...
			console.info(
				'MIME tree with multiple "text/html" nodes under "multipart/alternative"... trying with first'
			);
		}
		return htmlNodes[0];
	}

	throw new Error(
		'Unhandled MIME tree with a "multipart/alternative" root but no "text/html" child'
	);
}

function getHtmlNodeOfMultipartRelated(node: MultipartMimeNode): LeafMimeNode {
	if (node.contentType !== 'multipart/related') {
		throw new Error('Expected input to be multipart/related');
	}

	const htmlNodes = node.children.filter(childNode => childNode.contentType === 'text/html');
	if (htmlNodes.length >= 1 && htmlNodes[0].mimeNodeType === 'leaf') {
		if (htmlNodes.length > 1) {
			// Try the first...
			console.info(
				'MIME tree with no content-type.type param and multiple "text/html" nodes... trying with first'
			);
		}
		return htmlNodes[0];
	}

	// No HTML node... but maybe a multipart/alternative node?
	const multipartAlternativeNodes = node.children.filter(
		childNode => childNode.contentType === 'multipart/alternative'
	);
	if (multipartAlternativeNodes.length === 1) {
		return getHtmlNodeOfMultipartAlternative(multipartAlternativeNodes[0]);
	}

	throw new Error(
		'Unhandled MIME tree with a "multipart/alternative" root but no "text/html" child'
	);
}

export function getMainHtmlNode(root: MimeNode): LeafMimeNode {
	// Find the main HTML node
	if (root.mimeNodeType === 'leaf') {
		if (root.contentType === 'text/html') {
			return root;
		} else {
			throw new Error(`Unhandled MIME tree with a "${root.contentType}" root node`);
		}
	} else {
		if (root.contentType === 'multipart/alternative') {
			return getHtmlNodeOfMultipartAlternative(root);
		} else if (root.contentType === 'multipart/related') {
			const relatedType = root.contentTypeType;

			if (!relatedType) {
				// Search for single HTML node
				return getHtmlNodeOfMultipartRelated(root);
			}

			const relatedNodes = root.children.filter(node => node.contentType === relatedType);
			if (relatedNodes.length <= 0) {
				throw new Error(
					`Expected to find a single child with content-type matching "multipart/related" type param of "${relatedType}"`
				);
			} else if (relatedNodes.length > 1) {
				console.warn(
					`Expected to find a single child with content-type matching "multipart/related" type param of "${relatedType}", but found ${relatedNodes.length}`
				);
			}

			const relatedNode = relatedNodes[0];

			console.dir({
				relatedType,
				relatedNode,
			});

			if (relatedNode.mimeNodeType === 'leaf') {
				if (relatedNode.contentType === 'text/html') {
					return relatedNode;
				} else {
					throw new Error(
						`Unhandled MIME tree with a "${relatedNode.contentType}" child of "multipart/related"`
					);
				}
			} else if (relatedNode.contentType === 'multipart/alternative') {
				return getHtmlNodeOfMultipartAlternative(relatedNode);
			} else {
				throw new Error(
					`Unhandled MIME tree with a "${relatedNode.contentType}" child of "multipart/related"`
				);
			}
		} else if (
			(root.contentType === 'multipart/alternative' ||
				root.contentType === 'multipart/mixed') &&
			root.children.length > 0 &&
			root.children[0].mimeNodeType === 'leaf' &&
			root.children[0].contentType === 'text/html'
		) {
			return root.children[0];
		} else if (
			root.contentType === 'multipart/mixed' &&
			root.children.length > 0 &&
			root.children[0].mimeNodeType === 'multipart' &&
			root.children[0].contentType === 'multipart/related' &&
			root.children[0].children.length > 0 &&
			root.children[0].children[0].mimeNodeType === 'leaf' &&
			root.children[0].children[0].contentType === 'text/html'
		) {
			return root.children[0].children[0];
		} else if (
			root.contentType === 'multipart/mixed' &&
			root.children.length > 0 &&
			root.children[0].mimeNodeType === 'multipart' &&
			root.children[0].contentType === 'multipart/related' &&
			root.children[0].children.length > 0 &&
			root.children[0].children[0].mimeNodeType === 'multipart' &&
			root.children[0].children[0].contentType === 'multipart/alternative' &&
			root.children[0].children[0].children[0].mimeNodeType === 'leaf' &&
			root.children[0].children[0].children[0].contentType === 'text/html'
		) {
			return root.children[0].children[0].children[0];
		} else {
			throw new Error(`Unhandled MIME tree with a "${root.contentType}" root node`);
		}
	}
}
